import React from "react";
import "assets/sass/user/configuration/Configuration.scss";

export class Configuration extends React.Component {
    render() {
        return (
            <div className="dashboard-config">
                <h5 className="dashboard-title">Configuración</h5>
                <div className="config-content">
                    {this.props.children}
                </div>
            </div>
        )
    }
}